import { createContext, useContext } from 'react';
import type { Socket } from 'socket.io-client';

export interface JoinResult {
  success: boolean;
  room?: string;
  error?:
    | 'unauthorized'
    | 'authentication_required'
    | 'validation_error'
    | 'internal_error'
    | 'timeout'
    | 'not_connected';
  message?: string;
}

export interface SocketContextType {
  socket: Socket | null;
  isConnected: boolean;
  hasConnectedOnce: boolean;
  reconnectCount: number;
  joinContainer: (containerId: string) => Promise<JoinResult>;
  leaveContainer: (containerId: string) => void;
  joinAnalysis: (jobId: string) => Promise<JoinResult>;
  leaveAnalysis: (jobId: string) => void;
  joinImprovements: (jobId: string) => Promise<JoinResult>;
  leaveImprovements: (jobId: string) => void;
  joinJob: (jobId: string) => Promise<JoinResult>;
  leaveJob: (jobId: string) => void;
  joinTask: (taskId: string) => Promise<JoinResult>;
  leaveTask: (taskId: string) => void;
}

export const SocketContext = createContext<SocketContextType | undefined>(undefined);

export function useSocket() {
  const context = useContext(SocketContext);
  if (context === undefined) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
}
